// extracted by mini-css-extract-plugin
export default {"wrapper":"_b760b521"};